<template>
    <div class="text-xs">
        <div v-show="hasFocus || value" class="relative">
            <input ref="input" type="text"
                v-model="value"
                @focus="hasFocus = true"
                @blur="blur()"
                @keydown.enter="setFilter()"
                class="reset block py-1 px-2 bg-gray-300 border-0 rounded-full focus:outline-none focus:ring"
            >
            <div class="absolute right-2 top-1 pl-1 border-l border-gray-400">
                <button type="button" v-if="hasFocus" @click="setFilter()">
                    <icon name="search" />
                </button>
                <button type="button" v-else @click="unsetFilter()">
                    <icon name="x" />
                </button>
            </div>
        </div>
        <label for="user-search" @click="focus()" v-show="! (hasFocus || value)" class="reset relative block py-1 px-2 text-xs bg-gray-300 rounded-full ">
            <span class="italic whitespace-nowrap">vyhledat uživatele</span>
        </label>
    </div>
</template>

<script>
export default {
    data() {
        return {
            value: null,
            filter: 'filter[user_search]',
            hasFocus: false,
        }
    },

    methods: {
        focus() {
            this.hasFocus = true;
            this.$nextTick(() => this.$refs.input.focus());
        },
        blur() {
            // input blur must be delayed otherwie search button gets hidden before it can trigger its click handler
            setTimeout(() => {
                this.hasFocus = false;
            }, 500);
        },
        setFilter() {
            Uri().addQuery(this.filter, this.value).redirect();
        },
        unsetFilter() {
            Uri().removeQuery(this.filter).redirect();
        },
    },

    mounted() {
        this.value = Uri().getQuery(this.filter);
    }
}
</script>

<style lang="scss" scoped>
</style>
